import { map, uniqBy } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { filterByFiltering } from '../../selectors/selectors';
import TableColumnFilter from '../TableColumnFilter';
import TableRecordTooltip from '../TableRecordTooltip';

const TotalUsersServiceTable = ({ records, userType, filtering, filter }) => {
  const filterRecords = filterByFiltering(records, filtering);
  const tenants = map(uniqBy(records, 'tenant'), record => record.tenant);

  return (
    <div>
      {records.length > 0
        ? <table className="table table-fixed">
            <thead>
              <tr>
                <th>
                  <TableColumnFilter
                    id="serviceFilter"
                    options={tenants}
                    filtering={filtering.tenant || []}
                    onSelectHandler={filter('tenant')}
                  >
                    Tenant
                  </TableColumnFilter>
                </th>
                <th>
                  {userType}
                </th>
              </tr>
            </thead>
            <tbody>
              {filterRecords.map(record =>
                <tr key={record.tenant}>
                  <td>
                    <TableRecordTooltip text={record.tenant} />
                  </td>
                  <td>
                    {record.all_users}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        : <div className="empty-records">
            <p>There are no quota statistics at this time.</p>
          </div>}
    </div>
  );
};

TotalUsersServiceTable.propTypes = {
  records: PropTypes.array,
  filtering: PropTypes.object.isRequired,
  filter: PropTypes.func.isRequired,
  userType: PropTypes.string.isRequired
};

export default TotalUsersServiceTable;
